module.exports = __webpack_public_path__ + "static/media/hotelios_zakladni_logo_bila.ea2546c0.svg";